export default (el, eventName, props) => {
  const customEvent = new CustomEvent(eventName, {
    detail: props
  });

  el.dispatchEvent(customEvent);
};
